module.exports = __webpack_public_path__ + "static/media/gambia.3598fa83.png";